import {
  DEFAULT_TICKET_TYPES,
  TICKET_ATTRIBUTE_TYPES
} from '../config';

export function buildTicketTypesArray(fulfillmentMethods = [], {exclude = []} = {}) {
  if (!fulfillmentMethods || fulfillmentMethods.length === 0) {
    return [];
  }

  try {
    return DEFAULT_TICKET_TYPES.reduce((accum, ticketType) => {
      if (exclude.includes(ticketType.ticketType)) {
        return accum;
      }

      const matchingFulfillmentMethod = fulfillmentMethods.find((fm) => {
        return fm.ticketMedium === ticketType.ticketType;
      });

      if (matchingFulfillmentMethod) {
        if (matchingFulfillmentMethod.ticketMedium === 'FlashSeat') {
          matchingFulfillmentMethod.name = matchingFulfillmentMethod.name.split(' - ')[0].toUpperCase();
        }
        if (matchingFulfillmentMethod.name === 'Local Delivery') {
          matchingFulfillmentMethod.name = matchingFulfillmentMethod.name.replace(/ /g, '');
        }
        if (matchingFulfillmentMethod.name.toLowerCase() === 'royal mail' || matchingFulfillmentMethod.name.toLowerCase() === 'deutsche post' || matchingFulfillmentMethod.name.toLowerCase() === 'courier') {
          matchingFulfillmentMethod.name = 'Shipping';
        }
        return [
          {
            ...matchingFulfillmentMethod,
            ...ticketType
          }, ...accum
        ];
      }

      return accum;
    }, []);
  } catch (e) {
    console.trace('Problem parsing fulfillmentMethods', e);
    return [];
  }
}

// Loop through the seatTraits as returned by the event API,
// then build the arrays for app state
export function getTicketAttributesByType(seatTraits = []) {
  return seatTraits.reduce((accumulator, current) => {
    if (current.type === TICKET_ATTRIBUTE_TYPES.TICKET_FEATURE) {
      accumulator.listingFeatures.push(current);
    }
    if (current.type === TICKET_ATTRIBUTE_TYPES.SELLER_COMMENTS) {
      accumulator.listingComments.push(current);
    }
    if(current.type === TICKET_ATTRIBUTE_TYPES.LISTING_DISCLOSURE) {
      accumulator.listingLimitations.push(current);
    }
    if(current.type === TICKET_ATTRIBUTE_TYPES.LISTING_RESTRICTION) {
      accumulator.listingRestrictions.push(current);
    }
    if(current.type === TICKET_ATTRIBUTE_TYPES.LISTING_CONNECTION) {
      accumulator.listingConnections.push(current);
    }
    return accumulator;
  }, {
    listingFeatures: [],
    listingComments: [],
    listingLimitations: [],
    listingRestrictions: [],
    listingConnections: []
  });
}

export function getAreAllBarcodeFieldsValid(barcodeFields) {
  return barcodeFields.length && barcodeFields.every(({isValid}) => isValid);
}

export const mapCountryDataToLabelValue = (data) => {
  const objValuesArray = Object.values(data);
  const updatedData = objValuesArray.map(({
    countryCode, countryName, ...otherProps
  }) => ({
    label: countryName,
    value: countryCode,
    countryName,
    countryCode,
    ...otherProps
  }));
  return updatedData;
};

export const getDisclosureMsgType = (eventMetadata, shouldExcludeEUBiz, fulfillmentMethods) => {
  const listingAgreement = getListingAgreementProp(eventMetadata);
  if (shouldExcludeEUBiz) {
    return {
      type: "SellerFramework",
      link: null
    };
  } else if (listingAgreement) {
    let link = JSON.parse(listingAgreement)?.contentURL;
    return {
      type: "ListingAgreement",
      link
    };
  } else if (!fulfillmentMethods || fulfillmentMethods?.length === 0) {
    return {
      type: "ListingExpired",
      link: null
    };
  } else {
    return false;
  }
};

function getListingAgreementProp(eventMetadata) {
  return eventMetadata?.dynamicAttributes?.find(
    (attr) => attr.name === "sfr.listingDenied"
  )?.value;
}

export const getIsSingleTicketType = (fulfillmentMethods) => {
  if (fulfillmentMethods?.length === 1) {
    return true;
  } else if (fulfillmentMethods?.length === 2) {
    return fulfillmentMethods.some((method) => method.name === 'LMS');
  } else {
    return false;
  }
};

/**
 * This method will check if the disclosure should be shown or not
 * If the message type is agreement, it should appear only if there aren't fulfillmentMethods or
 *  the user is not allowed and the reason is not that the seller info is missing
 * @param {object} message the disclosure message
 * @param {array} fulfillmentMethods the available fulfillmentMethods
 * @param {boolean} isSellerEligible if the seller is eligible for selling or not
 * @param {string} reasonCode the reason code why the seller is not allowed
 * @returns true if the disclosure should be shown, false otherwise
 */
export const shouldShowDisclosure = (message, fulfillmentMethods, isSellerEligible, reasonCode) => {
  return !!message && !!message.type && (message.type !== 'ListingAgreement' || !fulfillmentMethods || fulfillmentMethods?.length == 0 ||
    (!isSellerEligible && reasonCode !== 'sellerinfoblock'));
};
